import React, { useState } from "react";
import SectionHeader from "./SectionHeader";
import { CardElement } from "@stripe/react-stripe-js";







const formatPhone = (raw) => {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "").slice(0, 10);
  if (digits.length >= 6) return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
  if (digits.length >= 3) return `(${digits.slice(0,3)}) ${digits.slice(3)}`;
  if (digits.length > 0) return `(${digits}`;
  return "";
};

export default function CheckoutDetailsCard({
  checkoutData,
  setCheckoutData,
  savedCard,
  onChangeCard,
  onValidationChange,
  validateRef
}) {
const hasFullAddress = checkoutData.address && checkoutData.city && checkoutData.zip && checkoutData.state && checkoutData.firstName && checkoutData.lastName && checkoutData.email && checkoutData.phone;
const [editingShipping, setEditingShipping] = useState(!hasFullAddress);
const [errors, setErrors] = useState({});

const validateShipping = () => {
  const required = { firstName: "First name", lastName: "Last name", email: "Email", phone: "Phone", address: "Street address", city: "City", state: "State", zip: "ZIP code" };
  const newErrors = {};
  Object.entries(required).forEach(([field, label]) => {
    if (!checkoutData[field]?.trim()) newErrors[field] = `${label} is required`;
  });
  setErrors(newErrors);
  const valid = Object.keys(newErrors).length === 0;
  onValidationChange?.(valid);
  return valid;
};


React.useEffect(() => {
  if (validateRef) validateRef.current = validateShipping;
});

const handleChange = (field, value) => {
  setCheckoutData(prev => ({ ...prev, [field]: value }));
};

// Format phone on mount if it's raw digits
React.useEffect(() => {
  if (checkoutData.phone) {
    setCheckoutData(prev => ({ ...prev, phone: formatPhone(prev.phone) }));
  }
}, []);

 

  return (
    <div style={styles.outerCard}>

      {/* SHIPPING ADDRESS */}
      <SectionHeader title="Shipping Address" />

{!editingShipping ? (
        <div style={{
          border: "1px solid #E4E7EC",
          borderRadius: 14,
          background: "#F7F8FB",
          padding: "16px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start"
        }}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: "#111", marginBottom: 4 }}>
              {checkoutData.firstName} {checkoutData.lastName}
            </div>
            <div style={{ fontSize: 13, color: "#6B7280", lineHeight: "22px" }}>
              {checkoutData.email}<br/>
              {checkoutData.phone}<br/>
              {checkoutData.address}{checkoutData.apartment ? `, ${checkoutData.apartment}` : ""}<br/>
              {checkoutData.city}, {checkoutData.state} {checkoutData.zip}<br/>
              {checkoutData.country}
            </div>
          </div>
          <button
            onClick={() => setEditingShipping(true)}
            style={{
              background: "none",
              border: "1px solid #E5E7EB",
              borderRadius: 8,
              padding: "6px 14px",
              fontSize: 13,
              fontWeight: 600,
              color: "#374151",
              cursor: "pointer",
              whiteSpace: "nowrap",
              marginLeft: 12
            }}
          >
            Edit
          </button>
        </div>
      ) : (
        <>
        <div style={styles.box}>

          <div style={styles.inputGroup}>
            <div style={styles.label}>Full Name</div>
            <div style={styles.doubleGrid}>
            <input style={{ ...styles.input, borderColor: errors.firstName ? "#ef4444" : "#D0D5DD" }} placeholder="First Name*" value={checkoutData.firstName}
  onChange={(e) => { handleChange("firstName", e.target.value); setErrors(p => ({ ...p, firstName: "" })); }} />
            <input style={{ ...styles.input, borderColor: errors.lastName ? "#ef4444" : "#D0D5DD" }} placeholder="Last Name*" value={checkoutData.lastName}
  onChange={(e) => { handleChange("lastName", e.target.value); setErrors(p => ({ ...p, lastName: "" })); }} />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <div style={styles.label}>Email Address</div>
           <input style={{ ...styles.input, borderColor: errors.email ? "#ef4444" : "#D0D5DD" }} placeholder="you@example.com*" value={checkoutData.email}
  onChange={(e) => { handleChange("email", e.target.value); setErrors(p => ({ ...p, email: "" })); }} />
          </div>

          <div style={styles.inputGroup}>
            <div style={styles.label}>Phone Number</div>
     <input style={{ ...styles.input, borderColor: errors.phone ? "#ef4444" : "#D0D5DD" }} placeholder="(555) 555-5555*" value={checkoutData.phone}
  onChange={(e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
    let formatted = digits;
    if (digits.length >= 6) formatted = `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
    else if (digits.length >= 3) formatted = `(${digits.slice(0,3)}) ${digits.slice(3)}`;
    else if (digits.length > 0) formatted = `(${digits}`;
    handleChange("phone", formatted);
    setErrors(p => ({ ...p, phone: "" }));
  }} />
          </div>

          <div style={styles.inputGroup}>
            <div style={styles.label}>Street Address</div>
<input style={{ ...styles.input, borderColor: errors.address ? "#ef4444" : "#D0D5DD" }} placeholder="1234 Ocean Blvd*" value={checkoutData.address}
  onChange={(e) => { handleChange("address", e.target.value); setErrors(p => ({ ...p, address: "" })); }} />
          </div>

          <div style={styles.inputGroup}>
            <div style={styles.label}>Apartment / Suite</div>
       <input style={styles.input} placeholder="Optional" value={checkoutData.apartment}
onChange={(e) => handleChange("apartment", e.target.value)}/>
          </div>

          <div style={styles.cityGrid}>
            <div>
              <div style={styles.label}>City</div>
  <input style={{ ...styles.input, borderColor: errors.city ? "#ef4444" : "#D0D5DD" }} placeholder="City*" value={checkoutData.city}
  onChange={(e) => { handleChange("city", e.target.value.replace(/\b\w/g, c => c.toUpperCase())); setErrors(p => ({ ...p, city: "" })); }} />
            </div>
            <div>
              <div style={styles.label}>State</div>
 <input style={{ ...styles.input, borderColor: errors.state ? "#ef4444" : "#D0D5DD" }} placeholder="FL*" value={checkoutData.state}
  onChange={(e) => { handleChange("state", e.target.value.toUpperCase().slice(0,2)); setErrors(p => ({ ...p, state: "" })); }} />
            </div>
            <div>
              <div style={styles.label}>ZIP Code</div>
       <input style={{ ...styles.input, borderColor: errors.zip ? "#ef4444" : "#D0D5DD" }} placeholder="33082*" value={checkoutData.zip}
  onChange={(e) => { handleChange("zip", e.target.value); setErrors(p => ({ ...p, zip: "" })); }} />
            </div>
          </div>

        </div>

 {editingShipping && Object.keys(errors).some(k => errors[k]) && (
          <div style={{ color: "#ef4444", fontSize: 13, fontWeight: 500, marginTop: 8 }}>
            Please fill in all required fields before continuing.
          </div>
        )}

        {editingShipping && (
      <button onClick={() => {
  if (validateShipping()) setEditingShipping(false);
}} style={{
  marginTop: 10, background: "none", border: "none",
  fontSize: 13, fontWeight: 600, color: "#635BFF", cursor: "pointer", padding: 0
}}>
  ← Save & collapse
</button>
        )}
        </>
      )}

      {/* BILLING DETAILS */}
      <div style={styles.billingSection}>
        <SectionHeader title="Billing Details" />
        <div style={styles.box}>
          {savedCard ? (
            <div style={{ padding: "20px" }}>
              <div style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "14px 16px", borderRadius: 12, border: "1px solid #E5E7EB",
                background: "#fff", marginBottom: 12
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <img src="https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg"
                    alt="card" style={{ width: 38, height: 24, objectFit: "contain" }} />
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#111" }}>
                      {savedCard.brand.charAt(0).toUpperCase() + savedCard.brand.slice(1)} •••• {savedCard.last4}
                    </div>
                    <div style={{ fontSize: 12, color: "#9CA3AF" }}>
                      Expires {savedCard.expMonth}/{savedCard.expYear}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: 11, color: "#10B981", fontWeight: 700 }}>
                  SAVED · Instant Checkout
                </div>
              </div>
              <button onClick={onChangeCard} style={{
                width: "100%", padding: "10px", borderRadius: 10,
                border: "1px solid #E5E7EB", background: "#F9FAFB",
                fontSize: 13, fontWeight: 600, color: "#6B7280", cursor: "pointer"
              }}>
                Use a different card
              </button>
            </div>
          ) : (
            <div style={{ padding: "20px" }}>
              <div style={{ marginBottom: 10, fontSize: 14, color: "#555" }}>Card Details</div>
              <div style={styles.cardContainer}><CardElement /></div>
            </div>
          )}
        </div>
      </div>

      {/* STRIPE TRUST BADGE */}
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        gap: 8, marginTop: 20, padding: "12px", borderRadius: 12,
        background: "#F9FAFB", border: "1px solid #E5E7EB"
      }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8 1L10 6H15L11 9.5L12.5 14.5L8 11.5L3.5 14.5L5 9.5L1 6H6L8 1Z" fill="#10B981"/>
        </svg>
        <span style={{ fontSize: 12, color: "#6B7280", fontWeight: 500 }}>
          Payments are secured and powered by
        </span>
        <span style={{ fontWeight: 700, fontSize: 13, color: "#635BFF", letterSpacing: "-0.3px" }}>stripe</span>
      </div>

    </div>
  );
}

const styles = {
  outerCard: {
    borderRadius: 22, padding: 28,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui",
    background: "linear-gradient(180deg,#ffffff 0%,#f6f8ff 100%)",
    border: "2px solid #ffffff",
    boxShadow: "0 0 30px rgba(120,170,255,0.18), 0 20px 50px rgba(0,0,0,0.10), 0 6px 18px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,1)"
  },
  billingSection: { marginTop: 32 },
  box: { border: "1px solid #E4E7EC", borderRadius: 14, overflow: "hidden", background: "#F7F8FB", padding: 20 },
  inputGroup: { marginBottom: 20 },
  label: { fontSize: 13, color: "#98A1B2", marginBottom: 8 },
  input: {
    width: "100%", padding: "14px 16px", borderRadius: 12,
    border: "1px solid #D0D5DD", background: "#fff", fontSize: 15,
    outline: "none", boxSizing: "border-box", transition: "all 0.2s ease"
  },
  doubleGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
  cityGrid: { display: "grid", gridTemplateColumns: "1.5fr 0.8fr 1fr", gap: 14 },
  cardContainer: { padding: "14px", border: "1px solid #D0D5DD", borderRadius: "12px", background: "#fff" }
};